import UIComponent from "../../common/UIComponent";
import SwitchComponent from "../switch/index.js"
import "./index.css";
export default class ConfigBtn extends UIComponent {
  constructor(elementId, interfaces) {
    super();
    this.interfaces = interfaces;
    this.elementId = elementId;
    this.Lang = interfaces.language;
    this.init();
  }

  init() {
    this.configComponent = document.createElement("div");
    this.configComponent.setAttribute("class", "vhallPlayer-config-component");
    this.configComponent.onmouseleave = this.handleComponentMouseLeave.bind(this)

    this.configBtn = document.createElement("span");
    this.configBtn.setAttribute("class", "vhallPlayer-config-btn");
    this.configBtn.onclick = this.handleBtnClick.bind(this);

    this.configPopup = document.createElement("div");
    this.configPopup.setAttribute("class", "vhallPlayer-config-popup");

    this.configBox = document.createElement('div');
    this.configBox.setAttribute("class", "vhallPlayer-config-box");
    
    if (!this.interfaces.isLive) {
      //循环开关
      this.configLoop = document.createElement("div");
      this.configLoop.setAttribute("class", "vhallPlayer-config-item loop");
      this.interfaces.isLive ? this.configLoop.classList.add("disabled") : undefined;
      this.configLoopText = document.createElement("span");
      this.configLoopText.setAttribute("class", "looptext");
      this.configLoopText.innerText = this.Lang.loop.title;

      this.configLoop.appendChild(this.configLoopText);
      this.configBox.appendChild(this.configLoop);

      this.configPopup.appendChild(this.configBox);
      this.configComponent.appendChild(this.configBtn);
      this.configComponent.appendChild(this.configPopup);

      this.insertElement(this.elementId, this.configComponent);

      new SwitchComponent(".vhallPlayer-config-item.loop", this.interfaces, {
        text: "",
        id: "loop",
        openCallback: this.openLoop,
        closeCallback: this.closeloop
      });
    }
  }

  openLoop() {
    this.interfaces.setLoop(true);
  }

  closeloop() {
    this.interfaces.setLoop(false);
  }

  // 点击设置按钮
  handleBtnClick(e) {
    e.stopPropagation();
    this.configBtn.classList.add("active");
    this.configPopup.style.display = "block";
    this.configBox.style.display = 'block';
  }

  handleComponentMouseLeave() {
    this.configBtn.classList.remove("active");
    this.configPopup.style.display = "none";
  }
}